export const STAY = 'STAY'
export const DRIVE = 'DRIVE'
export const DRIVE_STAY = 'DRIVE:STAY'
export const RENTAL_CAR_PRODUCT_TYPE = 'cars'

export const ADD_PRODUCT_OPTIONS = [
  {
    name: 'hotel',
    type: STAY,
    label: 'Add a hotel',
    id: 'add-a-hotel-checkbox'
  }
] as const

export const CALENDAR_POPOVER_SELECTOR =
  '[aria-label="Calendar navigation tooltip"]'
